<template>
  <footer class="footer">
    <div class="row text-align-center">
      <div class="column small-12 column-regulation">
        <a href="/regulamin2026.pdf" target="_blank" class="link">
          REGULAMIN LOTERII
        </a>
      </div>
    </div>
    <div class="row text-align-center footer--row">
      <div class="column small-12 text-center">
        <img src="/images/warn.png" alt="Ostrzeżenia alkoholowe: 18+, zakaz spożywania w ciąży, zakaz prowadzenia po alkoholu." class="warn-icon" />
        Pij odpowiedzialnie
      </div>
      <div class="column small-12 text-center column-links">
        <router-link to="/kodeks-postepowania" class="link">
          Kodeks postępowania
        </router-link>
        <a href="https://grupazywiec.pl/polityka-cookies/" target="_blank" class="link">
          Polityka Cookies
        </a>
        <a href="#cookie-settings" class="link">
          Ustawienia cookies
        </a>
      </div>
      <div class="column small-12 text-center column-info">
        Nasze materiały przeznaczone są dla osób powyżej 18&nbsp;roku życia i&nbsp;nie należy ich przekazywać ani udostępniać osobom poniżej 18&nbsp;lat.
        <br />
        Jeżeli uważasz, że reklama naszego produktu narusza zasady Kodeksu Etyki Reklamy.
        <a href="https://radareklamy.pl/formularz-skargi" target="_blank">kliknij.</a>
        <br />
        Organizatorem loterii jest G3 Group sp.&nbsp;z&nbsp;o.o.
        <a href="https://www.g3.com.pl/" target="_blank">www.g3.com.pl</a>
      </div>
      <div class="column small-11 copyright">
        {{ currentYear }} <br />
        ALL <br />
        RIGHTS <br />
        RESERVED <br />
        ©
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  font-size: 0.875rem;
  line-height: 1.5rem;

  &--row {
    padding: 2rem 0;
    gap: 1rem;

    @include media-up(md) {
      gap: 2rem;
    }
  }

  .column-regulation {
    padding: 2rem 0;
    text-align: center;
    border-top: 1px solid #352d21;
    border-bottom: 1px solid #352d21;

    @include media-down(md) {
      padding: 1.5rem 0;
    }

    .link {
      padding-bottom: 0;
    }
  }

  .column-links {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .column-info {
    a {
      color: black;
    }
  }

  .warn-icon {
    height: 2rem;
    margin-right: 1rem;
  }
  .copyright {
    font-size: 0.5675rem;
    line-height: 0.625rem;
    letter-spacing: 3.3px;
  }
}

::v-deep button,
.link {
  display: block;
  color: #ffffff;
  text-decoration: none;
  text-transform: uppercase;
  font-family: $bold-font;
  font-size: 0.75rem;
  font-weight: 900;
  line-height: 1.5rem;
  padding: 0 1rem 0.5rem;
  transition: all 0.4s;
  transform: none;
  cursor: pointer;

  &:focus {
    color: #ffffff;
  }

  &:hover {
    transform: translateY(-6px) scale(1.1);
    color: #ffffff;

    @include media-down(md) {
      transform: translateY(-6px) scale(1.05);
    }
  }
}
</style>
